module.exports = __webpack_public_path__ + "img/1.a597c83d.svg";